<template>
  <div>
    <mt-header fixed title="关于我们">
      <router-link to="/index/profile" slot="left">
        <mt-button icon="back">返回</mt-button>
      </router-link>
    </mt-header>
    <p style="margin-top:40px;text-indent:2em;">
        万识防伪溯源平台是由中国防伪协会下属会员单位四川万识科技优先公司推出的为广大中小企业提供低门槛的产品防伪溯源服务平台。
    </p>
    <mt-cell title="联系地址">
        成都高新区盛安街401号1栋1单元19层1901号
    </mt-cell>
    <mt-cell title="联系电话">
        028-82384933、13800138000
    </mt-cell>
  </div>
</template>

<script>
export default {
};
</script>
<style scoped>
    p{padding:1em 1em 0 1em;line-height:2em;}
</style>